import { ISalesTypeItem } from '../../../../features/partner360/configuration/models/iSalesTypeItem'
import { IJbpSalesTypeItem } from '../models'

export const mapJbpSalesTypeToSalesType = (item: IJbpSalesTypeItem): ISalesTypeItem => {
  return {
    salesType: item.SalesType,
    salesTypeComment: `${item.SalesType}--tooltip-comment`,
    isDefault: item.IsDefault === 1,
  }
}
